import moment from 'moment-timezone';
import { DATE_SHORTCUTS } from './constants';

function calcShortcutInterval(shortcut) {
  switch (shortcut) {
  case DATE_SHORTCUTS.last1Min: return [moment().subtract(1, 'minutes').startOf('minute'), moment()];
  case DATE_SHORTCUTS.last120Sec: return [moment().subtract(120, 'seconds'), moment()];
  case DATE_SHORTCUTS.last15Mins: return [moment().subtract(15, 'minutes').startOf('minute'), moment()];
  case DATE_SHORTCUTS.last1Hour: return [moment().subtract(1, 'hours').startOf('minute'), moment()];
  case DATE_SHORTCUTS.last2Hours: return [moment().subtract(2, 'hours').startOf('minute'), moment()];
  case DATE_SHORTCUTS.last6Hours: return [moment().subtract(6, 'hours').startOf('minute'), moment()];
  case DATE_SHORTCUTS.past24Hours: return [moment().subtract(24, 'hours').startOf('hour'), moment().startOf('hour')];
  case DATE_SHORTCUTS.today: return [moment().startOf('day'), moment()];
  case DATE_SHORTCUTS.yesterday: return [moment().subtract(1, 'days').startOf('day'), moment().subtract(1, 'days').endOf('day')];
  case DATE_SHORTCUTS.lastWeek: return [moment().subtract(1, 'week').startOf('week'), moment().subtract(1, 'week').endOf('week')];
  case DATE_SHORTCUTS.thisMonth: return [moment().startOf('month'), moment().startOf('day')];
  case DATE_SHORTCUTS.lastMonth: return [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')];
  case DATE_SHORTCUTS.past7Days: return [moment().subtract(7, 'days').startOf('day'), moment().subtract(1, 'day').endOf('day')];
  case DATE_SHORTCUTS.past15Days: return [moment().subtract(15, 'days').startOf('day'), moment().subtract(1, 'day').endOf('day')];
  case DATE_SHORTCUTS.past30Days: return [moment().subtract(30, 'days').startOf('day'), moment().subtract(1, 'day').endOf('day')];
  case DATE_SHORTCUTS.past90Days: return [moment().subtract(90, 'days').startOf('day'), moment().subtract(1, 'day').endOf('day')];
  case DATE_SHORTCUTS.past1Year: return [moment().subtract(1, 'year').startOf('day'), moment().subtract(1, 'day').endOf('day')];
  default: return [];
  }
}

export default calcShortcutInterval;
